import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import CUICenter from '../CUICenter/CUICenter';
import CUIImage from '../CUIImage/CUIImage';

const CUIHomepageCardImageSection = (_ref) => {
  let {
    src,
    alt
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["src", "alt"]);

  return /*#__PURE__*/_jsx(CUICenter, Object.assign({
    display: {
      base: 'none',
      md: 'block'
    },
    maxW: "50%",
    objectFit: "cover",
    p: 8
  }, rest, {
    children: /*#__PURE__*/_jsx(CUICenter, {
      height: "100%",
      children: /*#__PURE__*/_jsx(CUIImage, {
        alt: alt,
        src: src
      })
    })
  }));
};

export default CUIHomepageCardImageSection;